const stanceStyles: Record<string, string> = {
  支持: "bg-accent-100 text-accent-800 border-accent-200",
  质疑: "bg-primary-100 text-primary-800 border-primary-200",
  中立: "bg-secondary-100 text-secondary-900 border-secondary-200",
};

export default function StanceTag({ stance }: { stance: string }) {
  const style = stanceStyles[stance] ?? stanceStyles["中立"];

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full border text-xs whitespace-nowrap ${style}`}
    >
      <i className="ri-arrow-left-right-line w-3.5 h-3.5 flex items-center justify-center" />
      {stance}
    </span>
  );
}